import { useEffect } from "react";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { PageWrapper, PageWrapperProps } from "../../common-ui/PageWrapper";
import { Network } from "../../API";
import {
  NetworkNotifications,
  alphabetizeNetworks,
  useAllNetworks
} from "./networkUtils";

const pageDetails: PageWrapperProps = {
  className: "Networks",
  headerText: "Networks"
};

export const Networks = ({
  disableVirtualization
}: {
  disableVirtualization?: boolean;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { networks, status, getAllNetworks } = useAllNetworks();

  useEffect(() => {
    getAllNetworks();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let alphabetizedNetworks: Network[] = [];
  if (networks) {
    alphabetizedNetworks = alphabetizeNetworks(networks);
  }

  const columns: GridColDef[] = [
    {
      headerName: t("Name"),
      field: "name",
      flex: 1
    },
    {
      headerName: t("Sponsor"),
      field: "sponsorName",
      valueGetter: (params) => params.row.sponsor?.name ?? "N/A",
      flex: 1
    },
    {
      headerName: t("ID"),
      field: "id",
      flex: 1
    }
  ];

  return (
    <PageWrapper {...pageDetails}>
      <div>
        <button onClick={() => navigate(`/networks/new`)}>
          {t("New Network")}
        </button>
      </div>
      <DataGrid
        columns={columns}
        rows={alphabetizedNetworks || []}
        aria-label="networks-table"
        disableVirtualization={disableVirtualization}
        loading={status === "loading"}
        localeText={{
          noRowsLabel: t(NetworkNotifications.NoNetworks)
        }}
        onRowClick={(rowData) => {
          const { row } = rowData;
          const { id } = row;
          if (id) {
            navigate(`${id}`);
          }
        }}
      />
    </PageWrapper>
  );
};
